import { render } from "./CharacterEditor.vue?vue&type=template&id=585823c6"
import script from "./CharacterEditor.vue?vue&type=script&lang=js"
export * from "./CharacterEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__